export default __webpack_public_path__ + "static/media/amex.557acb7e.svg";